// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VeeValidate, {
  Validator
} from 'vee-validate'

import "./assets/css/bootstrap.min.css";
import './assets/css/animate.css'
import './assets/css/main.css'

import $ from 'jquery'

Vue.use(VeeValidate, {
    locale: 'zh_CN'
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js